import { formatMoney } from '@staccx/bento'
import { formatDate } from '../../../V3/helpers/formatDate'

export function parking() {
  return [
    {
      accessorKey: 'date',
      id: 'date',
      header: () => <span>Dato</span>,
      cell: ({ row }) => {
        const date = formatDate(row.original.date)
        return date ?? 'Ukjent'
      },
      meta: { alignmentType: 'date' },
    },
    {
      accessorKey: 'description',
      id: 'description',
      header: () => <span>Beskrivelse</span>,
      cell: ({ row }) => {
        const description = row.original.description
        return description ?? 'Ukjent'
      },
      meta: { alignmentType: 'string' },
    },
    {
      accessorKey: 'price',
      id: 'price',
      header: () => <span>Pris</span>,
      cell: ({ row }) => {
        const amount = formatMoney(row.original.price)
        return amount ? `${amount} NOK` : 'Ukjent'
      },
      meta: { alignmentType: 'string' },
    },
  ]
}
